/**
 * Version name URL encoding utilities.
 *
 * Version names (e.g. `1.0.0-main.johndoe.42`) contain dots that trigger the "dot-rule" in web servers, which treats
 * dot-containing path segments as static file requests instead of SPA routes.
 *
 * Strategy: replace dots with `~` (tilde). Tilde is RFC 3986 unreserved, so `encodeURIComponent` won't double-encode
 * it. The decode step is applied explicitly before API calls so the backend always receives the real version name.
 */ /** Encode a version name for use in a URL path segment. e.g. `1.0.0-main.johndoe.42` → `1~0~0-main~johndoe~42` */ export function encodeVersionForUrl(name) {
    return name.replace(/\./g, '~');
}
/** Decode a version name from a URL path segment. Must be called before passing to API calls. */ export function decodeVersionFromUrl(encoded) {
    return encoded.replace(/~/g, '.');
}
